// Where the engine worker lives, in SOURCE form.
//
// `new Worker(new URL("./worker.ts", import.meta.url), { type: "module" })`
// written literally like this is the shape Vite and webpack 5 pattern-match
// to emit the worker as its own chunk and rewrite the URL. Hoisting the
// URL into a variable would defeat that — hence a module whose whole job
// is to hold the literal.
//
// The published build swaps this file for `worker-url.dist.ts`, which
// points at the separately-built `assets/engine.worker.js` instead. See
// vite.config.ts.

export function makeEngineWorker(): Worker {
  return new Worker(new URL("./worker.ts", import.meta.url), { type: "module" });
}
